import React, {useState} from "react";
import {Card, Button, Text, Flex, Box} from "rebass";
import {CardFooter, CardHeader, HR, LabeledText, Modal, SlideShow} from "../../../../Components";
import {Patient} from "../../../../Types";
import axios, {AxiosResponse} from "axios";
import {Simulate} from "react-dom/test-utils";
import {LoadingIcon} from "../../../../Components/Icons/LoadingIcon";
import { pseudoRandomBytes } from "crypto";


export class ResultsContainer extends React.Component<any, any> {
  private bundle_elements: any[];

  constructor(props) {
    super(props);

    this.state = {
      selected_bundle: -1
    }

    this.bundle_elements = []
  }

  componentDidMount() {
    this.fetchBundles()
  }


  // Fetch the event ids of the user's vvp tests
  fetchBundles = async () => {
    // TODO edit api to send a list of ids as opposed to a list of dics
    const handleError = (error) => {
      console.log(error);
    }

    await axios.post(
      "/api_chart/vvp_results",
      {clinic_user_id: this.props.patient.clinic_user_id}
    ).then(
      (response) => {
        if (response.data["results"] !== undefined) {
          const bundles = Object.entries(response.data["results"])
          // @ts-ignore
          for (let [i, [bundle_label, bundle_results]] of bundles.entries()) {
            this.bundle_elements.push(<Bundle key={bundle_label} header={bundle_label} bundleNumber={i + 1 + " of " + bundles.length} results={bundle_results} changeBundle={(n) => this.changeBundle(n)}/>)
          }

        }else console.log("Couldn't fetch results", response.data)
      },
      handleError
    )

    this.setState({selected_bundle: 0})
  }

  changeBundle = (n) => {
    this.setState((state) => {

      if (state.selected_bundle + n < 0 || state.selected_bundle + n >= this.bundle_elements.length) {
        return
      }

      return {selected_bundle: state.selected_bundle + n}
    })
  }

  render() {
    let bundle_element: JSX.Element | undefined = this.bundle_elements[this.state.selected_bundle]

    return (
      <div>
        {bundle_element}
      </div>
    )
  }

}


export class Bundle extends React.Component<any, any> {

  constructor(props) {
    super(props);

    this.state = {
      slides: Array(this.props.results.length).fill(loadingSlide),
      slides2: Array(this.props.results.length).fill(loadingSlide),
      current_result: 0,
      isResultOpen: false
    }
  }

  componentDidMount() {
    this.makeSlides()
  }

  // Fetch the images themselves
  makeSlides = async () => {
    //TODO remove splice
    //event_ids.splice(5, 12)

    const promises: any = []
    for (let [i, result] of this.props.results.entries()) {
      promises.push(
        fetchPreview(result).then((preview) => this.makeSlide(i+1, result.test_id, preview))
      )
    }
  }

  makeSlide = async (slide_number, event_id, result_preview) => {

    let slide : JSX.Element;
    let slide2 : JSX.Element;

    // No vvp results
    if (event_id === "false") {
      slide = (
        <div className="vvp_results-error">
          <div className="vvp_results-error-text">Patient {this.props.patient.user_name} isn't associated with any results</div>
        </div>
      )
      slide2 = slide;
    }
    // Invalid/corrupted result
    else if (result_preview.length == 0) {
      slide = (
        <div className="vvp_results-error">
          <div className="vvp_results-error-text">Failed to load result with id: {event_id}</div>
        </div>
      )
      slide2 = slide;
    }
    else {
      slide = <img className="vvp_results-image" src={URL.createObjectURL(result_preview[0])} alt="page 1"/>
      slide2 = <img className="vvp_results-image" src={URL.createObjectURL(result_preview[1])} alt="page 2"/>
    }

    // TODO encode images before sending them
    // Successful download
    this.setState((state) => {state.slides[slide_number - 1] = slide; return {}})
    this.setState((state) => {state.slides2[slide_number - 1] = slide2; return {}})
  }

  render() {
    const result = this.props.results[this.state.current_result]
    const bundleDate = new Date(parseInt(result.bundle_unix_time) * 1000)
    const resultDate = new Date(parseInt(result.test_unix_time) * 1000)

    const previousResult = this.state.slides[this.state.current_result - 1]
    const currentResult = this.state.slides[this.state.current_result]
    const currentResult2 = this.state.slides2[this.state.current_result]
    const nextResult = this.state.slides[this.state.current_result + 1]

    return (
      <>
        <Card paddingBottom={"32px"}>
          <CardHeader
            left={
              <img className="svg_button" src="/ui/next.svg" alt="previews bundle"
                   style={{
                     width: "28px",
                     marginLeft: "20px",
                     transform: "scaleX(-1)"
                   }}
                   onClick={() => this.props.changeBundle(-1)}
              />
            }
            center={
              <Flex flexDirection="column" justifyContent={"space-between"}>
                <Flex flexDirection="row" marginTop={1} justifyContent={"center"} justifyItems={"center"} justifySelf={"center"}>
                  <LabeledText label={"Bundle "} value={this.props.bundleNumber} fontSize={4} paddingLeft={2} paddingRight={2}/>
                  <LabeledText label={"starting on"} value={formatDate(bundleDate)} fontSize={4} paddingLeft={2}/>
                </Flex>
                <Flex flexDirection="row" marginTop={1} justifyContent={"center"} justifyItems={"center"} justifySelf={"center"}>
                  <LabeledText label={"Test taken on"} value={formatDate(resultDate)} fontSize={3} paddingLeft={2} paddingRight={3}/>
                  <LabeledText label={"At"} value={formatTime(resultDate)} fontSize={3} paddingLeft={2} paddingRight={3}/>
                </Flex>
              </Flex>
            }
            right={
              <img className="svg_button" src="/ui/next.svg" alt="previews bundle"
                   style={{
                     width: "28px",
                     marginRight: "20px"
                   }}
                   onClick={() => this.props.changeBundle(+1)}
              />
            }
          />

          <SlideShow
            init_slide_number={1}
            slides={this.state.slides}
            onSlideClick={(slide_number) => {
              this.setState({isResultOpen: true})
            }}
            passSlideNumber={(slide_number) => this.setState({current_result: slide_number - 1})}
          />
          <Box padding={3}>
            <HR/>
            <Text fontWeight="bold" textAlign="center" fontSize={4}>Export Results</Text>
            <Flex justifyContent="center">
              <MiniCard title="Current Result" event_id={this.props.results[this.state.current_result]?.test_id} />
              <MiniCard title="Current Bundle"/>
              <MiniCard title="All Results"/>
            </Flex>
          </Box>
        </Card>
        <Modal
          isOpen={this.state.isResultOpen}
          setIsOpen={(isOpen) => this.setState({isResultOpen: isOpen})}
          overflow="hide"
          backgroundColor="white"
        >
          <Flex>
            <Box width="35vw" backgroundColor={currentResult == undefined? "transparent":"white"} margin={2} marginRight={4}>
              {currentResult}
            </Box>
            <div style={{borderRight: "solid 1px #e7e7e7"}}/>
            <Box width="35vw" backgroundColor={previousResult == undefined? "transparent":"white"} margin={2} marginLeft={4}>
              {currentResult2}
            </Box>
          </Flex>
        </Modal>
      </>
    )
  }
}

const MiniCard = (props) => {
  const staticUrl = "https://dev.seevividly.com/api_chart/vvp_result/" + props.event_id;

  if(props.title === "Current Result"){
    return (
      <div style={{margin: 8, }}>
        <Text fontWeight="bold" textAlign="center" color="darkBlue">{props.title}</Text>
        <Flex>
          <Button margin={1} onClick={() => {
            axios.get("/api_chart/vvp_result/" + props.event_id + ".pdf", {responseType: 'blob'})
              .then((response) => {window.open(URL.createObjectURL(response.data))?.print()})
          }}
          >PRINT</Button>
          {/* <Button margin={1} onClick={() => openResult(props.event_id, "pdf")}>PDF</Button> */}
          {/* <Button margin={1} onClick={() => openResult(props.event_id, "svg")}>SVG</Button> */}
          <Button margin={1} onClick={() => window.open(staticUrl + "_page_1.svg",'_blank', "noreferrer")}>Page 1</Button>
          <Button margin={1} onClick={() => window.open(staticUrl + "_page_2.svg",'_blank', "noreferrer")}>Page 2</Button>
          <Button margin={1} onClick={() => window.open(staticUrl + ".json",'_blank', "noreferrer")}>JSON</Button>
        </Flex>
      </div>
    )
  }
  else
  {
  return (
    <div style={{margin: 8, }}>
      <Text fontWeight="bold" textAlign="center" color="darkBlue">{props.title}</Text>
      <Flex>
        <Button margin={1} onClick={() => {
          axios.get("/api_chart/vvp_result/" + props.event_id + ".pdf", {responseType: 'blob'})
            .then((response) => {window.open(URL.createObjectURL(response.data))?.print()})
        }}
        variant="disabled"
        >PRINT</Button>
        <Button margin={1} onClick={() => window.open(staticUrl + "_page_1.svg",'_blank', "noreferrer")} variant="disabled">Page 1</Button>
        <Button margin={1} onClick={() => window.open(staticUrl + "_page_2.svg",'_blank', "noreferrer")} variant="disabled">Page 2</Button>
        <Button margin={1} onClick={() => window.open(staticUrl + ".json",'_blank', "noreferrer")} variant="disabled">JSON</Button>
      </Flex>
    </div>
  )
  }
}

const fetchPreview = async (result) => {
  let preview : any = [];

  await axios.get("/api_chart/vvp_result/" + result.test_id + "_page_1.svg", {responseType: 'blob'}).then((response) => {
    preview[0] = ["image/svg+xml", "image/png", "image/jpg", "image/jpeg"].includes(response.data.type)? response.data : false
  });
  
  await axios.get("/api_chart/vvp_result/" + result.test_id + "_page_2.svg", {responseType: 'blob'}).then((response) => {
    preview[1] = ["image/svg+xml", "image/png", "image/jpg", "image/jpeg"].includes(response.data.type)? response.data : false
  });

  return preview;
}

const getOrdinal = (n: number) => {
  switch (n) {
    case 1: return "st"
    case 2: return "nd"
    case 3: return "rd"
    default: return "th"
  }
}

const formatDate = (date: Date) => {
  const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][date.getMonth()];
  return month + " " + date.getDay() + getOrdinal(date.getDay()) + " " + date.getFullYear()
}

const formatTime = (date: Date) => {
  return date.getHours() % 12 + ":" + date.getMinutes() + " " + (date.getHours() < 12? "am":"pm")
}


const loadingSlide = (
  <div className="vvp_results-error">
    <div style={{
      textAlign: "center",
      fontSize: "22px",
      position: "absolute",
      top: "45%",
      left: 0,
      bottom: 0,
      right: 0,
    }}>
      <LoadingIcon/>
    </div>
    <div style={{
      textAlign: "center",
      fontSize: "22px",
      position: "absolute",
      top: "35%",
      left: 0,
      bottom: 0,
      right: 0,
    }}>
      Fetching result...
    </div>
  </div>
)
